var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatorAviPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "url(#Creator-Avi-Placeholder_svg__paint0_linear_1699_5081)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Creator-Avi-Placeholder_svg__paint0_linear_1699_5081",
    x1: 12.736,
    y1: 11.321,
    x2: 35.379,
    y2: 46.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2898FF",
    stopOpacity: 0
  })))));
}
export default SvgCreatorAviPlaceholder;